import { combineReducers, type UnknownAction } from '@reduxjs/toolkit'
import { STORE_RESET_ALL } from 'constants/store'

import { rootReducer as auth } from 'modules/auth/stores'
import { rootReducer as user } from 'modules/user/stores'
import { rootReducer as invoice } from 'modules/invoice/stores'
import { rootReducer as notification } from 'modules/notification/stores'
import { rootReducer as notificationCentral } from 'modules/notification-central/stores'
import { rootReducer as policy } from 'modules/policy/stores'
import { rootReducer as legalPerson } from 'modules/legal-person/stores'
import { rootReducer as bill } from 'modules/bill/stores'
import { rootReducer as tutorial } from 'modules/tutorial/stores'
import { rootReducer as quiz } from 'modules/quiz/stores'
import { rootReducer as checkout } from 'modules/checkout/stores'
import { rootReducer as contract } from 'modules/contract/stores'
import { rootReducer as merchant } from 'modules/merchant/stores'
import { rootReducer as payment } from 'modules/payment/stores'
import obligationReducer from 'modules/payment-obligations/stores/obligation.store'
import { rootReducer as sidebar } from 'layouts/v2/sidebar/stores'
import { rootReducer as order } from 'modules/order/stores'

const appReducer = combineReducers({
  invoice,
  user,
  auth,
  notification,
  notificationCentral,
  policy,
  legalPerson,
  bill,
  tutorial,
  quiz,
  checkout,
  contract,
  merchant,
  payment,
  obligation: obligationReducer,
  order,
  sidebar,
})

export default function rootReducer(
  state: ReturnType<typeof appReducer> | undefined,
  action: UnknownAction
) {
  if (action.type === STORE_RESET_ALL) {
    state = undefined
  }
  return appReducer(state, action)
}
